/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * !!  WARNING: Do NOT edit this file!  !!
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 *
 * This is a GLOBAL layout file. Do not modify it just to
 * satisfy specific use cases. Please consider an
 * alternative approach. If you're unsure of what this means
 * or what to do, speak with a frontend engineer.
 *
 * @author Nathan Buchar <nathan.buchar@hellosign.com>
 */

import React from 'react';
import classnames from 'classnames';

import ErrorBoundary from 'common/components/error-boundary';
import HsStyleProvider from 'hellosign/common/style/hs-style-provider';
import AppTopBar from 'hellosign/components/app/header';
import AppFooter from 'hellosign/components/app/footer';
import AppSideBar from 'hellosign/components/app/sidebar';
import { useFeatureFlag } from 'hellospa/components/feature-flags';

import { DefaultLayoutContext } from './context';

export default function HelloSignLayoutResponsive(props) {
  const context = React.useContext(DefaultLayoutContext);

  const {
    app,
    locale,
    csrfToken,
    signature,
    siteCode,
    user,
    termsURL,
    privacyURL,
  } = context;

  const signatureModalProps = {
    signatureType: signature.type,
    settings: user.settings,
    csrfToken,
  };

  const isTemplatePageRedesign = useFeatureFlag('HelloSign_Stars_20210811_Template_Page_Redesign_P2');
  const isBackdropGlobalComponents = useFeatureFlag('HelloSign_Frontend_Ops_20220322_Backdrop_Global_Components_Experiment');
  const isBackdropBranding = useFeatureFlag('HelloSign_Frontend_Ops_20220322_Backdrop_Global_Branding_Experiment');
  const showLeftNavWinkExperiment = useFeatureFlag('showLeftNavWinkExperiment');

  const closeSidebar = React.useCallback(() => {
    document.body.classList.remove('responsive-layout__sidebar-open');
  }, []);

  return (
    <HsStyleProvider>
      <div
        className={classnames('responsive-layout', {
          'responsive-layout--backdrop': isBackdropGlobalComponents,
          'responsive-layout--full-bleed-content': props.fullBleedContent,
        })}
      >
        {!isBackdropGlobalComponents && (
          <div className="responsive-layout__screen" onClick={closeSidebar} />
        )}
        <div className="responsive-layout__wrapper">
          <div className="responsive-layout__header">
            <AppTopBar
              isBackdropGlobalComponents={isBackdropGlobalComponents}
              isBackdropBranding={isBackdropBranding}
              withSearch={props.withSearch}
              onSearch={props.onSearch}
              locale={locale}
              responsive
              app={app}
              referUrl={user.referUrl}
              siteCode={siteCode}
              showUpgradeButton={user.isFree}
              emailAddress={user.emailAddress}
              name={user.name}
              numDocsLeft={user.numDocsLeft}
              numFaxPagesLeft={user.numFaxPagesLeft}
              numApiDocsLeft={user.numApiDocsLeft}
              numTemplatesLeft={user.numTemplatesLeft}
              primarySignatureGuid={user.primarySignatureGuid}
              showApiCredits={user.showApiCredits}
              signatureModalProps={signatureModalProps}
              canAccessAdminConsole={user.canAccessAdminConsole}
              showLeftNavWinkExperiment={showLeftNavWinkExperiment}
              isFromSelfServeApi={user.isFromSelfServeApi} />
          </div>
          <div className="responsive-layout__sidebar-and-content">
            <div className="responsive-layout__sidebar">
              <AppSideBar
                isBackdropGlobalComponents={isBackdropGlobalComponents}
                app={app}
                showLeftNavWinkExperiment={showLeftNavWinkExperiment}
                isTemplatePageRedesign={isTemplatePageRedesign}
                canAccessBulkSendUI={user.canAccessBulkSendUI}
                canAccessAdminConsole={user.canAccessAdminConsole}
                canAccessTemplateConverter={user.canAccessTemplateConverter}
                canAccessTemplates={!user.isFree}
                activeItemId={
                  // At some point I'd like to just have the AppSideBar just use
                  // ReactRouter to figure out which item is active.
                  props.activeItemId
                }
                siteCode={siteCode}
                emailAddress={user.emailAddress}
                name={user.name} />
            </div>
            <div className="responsive-layout__content">
              {isBackdropGlobalComponents && (
                <div className="responsive-layout__screen" onClick={closeSidebar} />
              )}
              <div role="main" id="site-wrapper" className="responsive-layout__main">
                <ErrorBoundary>
                  {props.children}
                </ErrorBoundary>
              </div>
              {!isBackdropGlobalComponents && (
                <div className="responsive-layout__footer">
                  <AppFooter
                    siteCode={siteCode}
                    termsURL={termsURL}
                    privacyURL={privacyURL} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </HsStyleProvider>
  );
}
